import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { TNoticeProps } from './types';

export const Notice: FC<TNoticeProps> = ({ text, children, sx = {} }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				backgroundColor: '#0092de24',
				borderRadius: '12px',
				p: '20px',
				mt: '20px',
				width: 'calc(100% - 40px)',
				...sx,
			}}
		>
			<Typography
				sx={{
					fontSize: '3rem',
					color: '#016193',
					fontFamily: 'monospace',
					mr: 2,
					mt: -1,
					fontWeight: 'bold',
					textTransform: 'lowercase',
				}}
			>
				i
			</Typography>
			{!!text && (
				<Typography sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}>
					{text}
				</Typography>
			)}
			{!!children && (
				<Typography sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}>
					{children}
				</Typography>
			)}
		</Box>
	);
};
